import React from 'react';
import { makeStyles, DialogContent, Typography, Divider } from "../../../../index";
import { useTranslation } from "../../../../hooks/useTranslation";
import { OrganizationMenu } from "./OrganizationMenu";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        flex: '0 0 auto',
        flexDirection: 'row',
        alignItems: 'center',
        overflowY: 'visible',
    },
    divider: {
        // safariでheight:100%では高さが効かないため直指定する
        height: '24px !important',
    },
    selectAll: {
        margin: theme.spacing(0, 2),
        cursor: 'pointer',
        textDecoration: 'underline',
        textUnderlinePosition: 'from-font',
    },
}); });
export var UserSelectDialogToolbar = React.memo(function (props) {
    var showSelectAll = props.showSelectAll, organizations = props.organizations, selectedOrganization = props.selectedOrganization, onSelectOrganization = props.onSelectOrganization, onSelectAllUsers = props.onSelectAllUsers, onUnselectAllUsers = props.onUnselectAllUsers;
    var t = useTranslation().t;
    var classes = useStyles();
    var handleSelectAllUsers = function () {
        onSelectAllUsers === null || onSelectAllUsers === void 0 ? void 0 : onSelectAllUsers();
    };
    var handleUnselectAllUsers = function () {
        onUnselectAllUsers === null || onUnselectAllUsers === void 0 ? void 0 : onUnselectAllUsers();
    };
    return (React.createElement(DialogContent, { className: classes.root },
        React.createElement(OrganizationMenu, { organizations: organizations, selectedOrganization: selectedOrganization, onSelectOrganization: onSelectOrganization }),
        showSelectAll && (React.createElement(React.Fragment, null,
            React.createElement(Typography, { color: "primary", className: classes.selectAll, onClick: handleSelectAllUsers }, t('全て選ぶ')),
            React.createElement(Divider, { vertical: true, inset: true, className: classes.divider }),
            React.createElement(Typography, { color: "primary", className: classes.selectAll, onClick: handleUnselectAllUsers }, t('全て解除'))))));
});
